import { EERIE } from 'HubStyleTokens/colors';
// @ts-expect-error untyped
import FilterOperatorType from 'customer-data-filters/components/propTypes/FilterOperatorType';
import DeprecatedFilter from 'customer-data-filters/filterQueryFormat/operator/DeprecatedFilter';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import Small from 'UIComponents/elements/Small';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import ConditionWarningBanner from './ConditionWarningBanner';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ConstantFilterWarning = props => {
  const {
    condition
  } = props;
  const shouldRenderWarning = condition && condition.constructor === DeprecatedFilter;
  if (!shouldRenderWarning) {
    return null;
  }
  const includeAll = condition.value;
  return /*#__PURE__*/_jsx(ConditionWarningBanner, {
    children: /*#__PURE__*/_jsxs(UIFlex, {
      justify: "between",
      children: [/*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: includeAll ? 'customerDataFilters.deprecatedFilter.descriptionIncludeAll' : 'customerDataFilters.deprecatedFilter.descriptionExcludeAll'
        })
      }), /*#__PURE__*/_jsx(UITooltip, {
        placement: "bottom",
        title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: includeAll ? 'customerDataFilters.deprecatedFilter.infoIconDescriptionIncludeAll' : 'customerDataFilters.deprecatedFilter.infoIconDescriptionExcludeAll'
        }),
        use: "longform",
        children: /*#__PURE__*/_jsx(UIIcon, {
          color: EERIE,
          name: "info"
        })
      })]
    })
  });
};
ConstantFilterWarning.propTypes = {
  condition: FilterOperatorType.isRequired
};
export default ConstantFilterWarning;